import { Planet } from '@apeiron/planet'
import { styled } from '@mui/material'
import AttackSVG from '@public/icons/icon-stats-attack.svg'
import AttackRangeSVG from '@public/icons/icon-stats-attack-range.svg'
import AttackSpeedSVG from '@public/icons/icon-stats-attack-speed.svg'
import DefenseSVG from '@public/icons/icon-stats-defense.svg'
import HealthSVG from '@public/icons/icon-stats-health.svg'
import IntelligenceSVG from '@public/icons/icon-stats-intelligence.svg'
import MoveSpeedSVG from '@public/icons/icon-stats-move-speed.svg'
import ResistSVG from '@public/icons/icon-stats-resist.svg'
import { SectionContent } from '@src/components/planet/detail/SectionContent'
import ApeironStatsLabel from '@src/components/share/apeiron/ApeironStatsLabel'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

const GridContainer = styled('div')`
  display: grid;
  grid-column-gap: 72px;
  grid-row-gap: 12px;
  grid-template-columns: 1fr 1fr;
  padding: 12px 38px;
  ${props => props.theme.breakpoints.down('res480')} {
    grid-column-gap: 51px;
    grid-row-gap: 5px;
    padding: 17px 24px;
  }
`

const PlanetStats: FC<Props> = props => {
  const { planet } = props

  const { t } = useTranslation()

  return (
    <SectionContent>
      <GridContainer>
        <ApeironStatsLabel
          icon={HealthSVG}
          name={t('planet.detail.stats.item.health')}
          value={planet.health}
        />
        <ApeironStatsLabel
          icon={IntelligenceSVG}
          name={t('planet.detail.stats.item.critical_strike')}
          value={planet.critDmg}
        />
        <ApeironStatsLabel
          icon={ResistSVG}
          name={t('planet.detail.stats.item.energy')}
          value={planet.energy}
        />
        <ApeironStatsLabel
          icon={MoveSpeedSVG}
          name={t('planet.detail.stats.item.critical_chance')}
          value={planet.critChance}
        />
        <ApeironStatsLabel
          icon={AttackSVG}
          name={t('planet.detail.stats.item.attack_power')}
          value={planet.atkPow}
        />
        <ApeironStatsLabel
          icon={AttackRangeSVG}
          name={t('planet.detail.stats.item.attack_range')}
          value={planet.atkRange}
        />
        <ApeironStatsLabel
          icon={AttackSpeedSVG}
          name={t('planet.detail.stats.item.attack_speed')}
          value={planet.atkSpeed}
        />
        <ApeironStatsLabel
          icon={DefenseSVG}
          name={t('planet.detail.stats.item.armor')}
          value={planet.armor}
        />
      </GridContainer>
    </SectionContent>
  )
}

export default PlanetStats

type Props = {
  planet: Planet
}
